import { createSlice } from "@reduxjs/toolkit";

export const stateSlice = createSlice({
  name: "state",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    stateslist: [],
    model: false,
    error_msg: null,
    rowdata: {},
    listCount: 0,
    stateParams: {
      no_of_pages: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getStates: (state) => {
      return {
        ...state,
        loading: true

      };
    },
    stateListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.count / state.stateParams.page_size
      );
      console.log(action.payload.results);
      return {
        ...state,
        listCount: action.payload.count,
        stateslist: action.payload.results,
        loading: false,
        stateParams: {
          ...state.stateParams,
          no_of_pages: noofpages,
        },

      };

    },
    stateAdd: (state) => {
      return {
        ...state,
        loading: true,
      };

    },
    stateAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    stateEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: {
          id: action.payload.id,
          name: action.payload.name,
          country_id: action.payload.country?.id,
        },

      };
    },

    stateDelete: (state) => {
      return {
        ...state,
        loading: false

      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetStateParams: (state, action) => {
      return {
        ...state,
        stateParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return {
        ...state,
        loading: false,
        error_msg: action.payload
      };
    },

  }

});
export const {
  getStates,
  stateListSuccessful,
  stateAdd,
  stateAddSuccessful,
  stateEdit,
  stateEditSuccessful,
  stateDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetStateParams
} = stateSlice.actions;

export default stateSlice.reducer;
